import clsx from "clsx";

import Button from "components/Button";
import useStripeScript from "hooks/useStripeScript";

interface IProps {
  label: string;
  accountType: string;
  plan: string;
  disabled: boolean;
  className?: string;
  planAmount?: string;
}

export default function StripeCheckoutButton({
  label,
  plan,
  planAmount,
  disabled = true,
  className
}: Readonly<IProps>) {
  const { handleStripeCheckout } = useStripeScript({
    plan: plan,
    planAmount: planAmount ?? "0"
  });

  return (
    <Button
      className={clsx(
        "w-32 h-10 text-sm rounded-full",
        className,
        disabled
          ? "!bg-subtitle !ring-subtitle cursor-not-allowed"
          : "bg-gradient-to-r from-primary to-secondary"
      )}
      onClick={handleStripeCheckout}
      disabled={disabled}>
      {label}
    </Button>
  );
}
